<template>
  <div 
    class="sticky top-0 z-50 transition-colors duration-300"
    :class="isGraphics ? 'bg-[#f7f8fb]' : 'bg-[#0f0d0d]'"
  >
    <div class="relative px-4 md:px-6 pt-2 pb-2">
      <div
        class="relative w-full rounded-2xl ring-1 shadow-sm transition-colors duration-300"
        :class="isGraphics
          ? 'ring-neutral-200 bg-white/70 backdrop-blur' 
          : 'ring-neutral-700/50 bg-neutral-800/70 backdrop-blur'"
      >
        <div class="relative p-1">
          <div
            class="absolute top-1 bottom-1 left-1 w-1/2 rounded-xl shadow-sm transition-transform duration-300 ease-out"
            :class="isGraphics ? 'bg-neutral-900' : 'bg-white'"
            :style="{ transform: isGraphics ? 'translateX(100%)' : 'translateX(0)' }"
          ></div>
          <div class="relative grid grid-cols-2 gap-2">
            <button
              type="button"
              data-mode="dev"
              @click="goToDev"
              class="relative z-10 inline-flex w-full items-center justify-center gap-2 py-2 text-sm font-medium transition-colors duration-300 rounded-xl"
              :class="[!isGraphics ? 'text-neutral-900 active bg-transparent' : 'text-neutral-900 bg-white']"
            >
              <Code2 
                :size="16" 
                class="text-emerald-600 transition-colors duration-300"
              />
              <span class="transition-colors duration-300">Developer</span>
            </button>
            <button
              type="button"
              data-mode="graphics"
              @click="goToGraphics"
              class="relative z-10 inline-flex w-full items-center justify-center gap-2 py-2 text-sm font-medium transition-colors duration-300 rounded-xl"
              :class="[isGraphics ? 'text-white active bg-transparent' : 'bg-neutral-800/70']"
            >
              <Palette 
                :size="16" 
                class="text-sky-400 transition-colors duration-300"
              />
              <span class="transition-colors duration-300">Graphics</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Code2, Palette } from 'lucide-vue-next'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'PortfolioToggle',
  components: {
    Code2,
    Palette
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const isGraphics = computed(() => route.name === 'Graphics' || route.path === '/graphics')

    const goToDev = () => {
      if (route.path !== '/') {
        router.push('/')
      }
    }

    const goToGraphics = () => {
      if (route.path !== '/graphics') {
        router.push('/graphics')
      }
    }

    return {
      isGraphics,
      goToDev,
      goToGraphics
    }
  }
}
</script>

<style scoped>
button[data-mode="dev"].active {
  color: rgb(17 24 39) !important;
  background-color: transparent !important;
}

button[data-mode="dev"]:not(.active) {
  color: rgb(17 24 39) !important;
  background-color: white !important;
}

button[data-mode="graphics"].active {
  color: white !important;
  background-color: transparent !important;
}

button[data-mode="graphics"]:not(.active) {
  color: white !important;
  background-color: #1f1f1f !important;
}

button[data-mode="dev"].active,
button[data-mode="dev"].active span {
  color: rgb(17 24 39) !important;
}
</style>
